import { render, staticRenderFns } from "./EnvironmentAlert.vue?vue&type=template&id=5942da7a&scoped=true"
import script from "./EnvironmentAlert.vue?vue&type=script&lang=js"
export * from "./EnvironmentAlert.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentAlert.vue?vue&type=style&index=0&id=5942da7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942da7a",
  null
  
)

export default component.exports